export enum CALENDAR_FILTER_ITEM_TYPES {
  CHECKBOX,
  AMOUNT,
  DATE,
}
